module.exports = __webpack_public_path__ + "img/slider-arrow-left-icon.9a45dab7.svg";